const Colors = {
  primary: '#047857',
  secondary: '#014e38',
  white: '#ffffff',
  gray: '#8c8c8c',
  lightGray: '#f0f0f0',
  darkGray: '#434343',
  success: '#10b981',
  successLight: '#d1fae5',
  warning: '#faad14',
  warningLight: '#fef3c7',
  error: '#ef4444',
  errorLight: '#fee2e2',
  info: '#3b82f6',
  infoLight: '#dbeafe',
  totalHighlight: '#f0f9ff',
  balanceWarning: '#d97706',
  balanceWarningLight: '#fef3c7',
  installmentBorder: '#e1e5e9',
  installmentBackground: '#ffffff',
  installmentShadow: '0 1px 3px rgba(0,0,0,0.05)',
  textSecondary: '#666',
  textTertiary: '#888',
  textPrimary: '#262626',
  cardShadow: '0 2px 8px rgba(0,0,0,0.1)',
  cardShadowHover: '0 4px 16px rgba(0,0,0,0.15)'
};

export default Colors;